import React from 'react';
import { SvgIcon } from '../primitives';

const Printer = React.forwardRef(function Printer(props, ref) {
  return <SvgIcon {...props} ref={ref}><path d="M19 8H5a3 3 0 0 0-3 3v4h4v4h12v-4h4v-4a3 3 0 0 0-3-3Zm-3 9H8v-5h8v5Zm3-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM18 3H6v4h12V3Z" /></SvgIcon>;
});

export default Printer;
